import { render } from "./HeroiconsOutlineLockOpen.vue?vue&type=template&id=acb55d9a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLockOpen.vue"]])

export default __exports__